module.exports = __webpack_public_path__ + "static/media/Bran Stark 2.73317a10.jpg";